export function usd(cents: number) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
}

export function krwHint(cents: number) {
  const krw = Math.round((cents / 100) * 1380);
  return new Intl.NumberFormat("ko-KR", {
    style: "currency",
    currency: "KRW",
    maximumFractionDigits: 0,
  }).format(krw);
}

export type Quote = {
  nights: number;
  nightlyPrice: number;
  subtotal: number;
  cleaningFee: number;
  serviceFee: number;
  discount: number;
  totalAmount: number;
  depositAmount: number;
  remainingAmount: number;
  promoCode?: string;
  percentOff?: number;
};

export function quoteStay(input: {
  nightlyPrice: number;
  cleaningFee: number;
  nights: number;
  depositBps: number;
  percentOff?: number;
  promoCode?: string;
}): Quote {
  const { nightlyPrice, cleaningFee, nights, depositBps, percentOff, promoCode } = input;
  const subtotal = nightlyPrice * nights;
  const serviceFee = Math.round(subtotal * 0.12);
  const before = subtotal + cleaningFee + serviceFee;
  const discount = percentOff ? Math.round(before * (percentOff / 100)) : 0;
  const totalAmount = Math.max(0, before - discount);
  const depositAmount = Math.max(5000, Math.round(totalAmount * (depositBps / 10_000)));
  const remainingAmount = Math.max(0, totalAmount - depositAmount);
  return {
    nights,
    nightlyPrice,
    subtotal,
    cleaningFee,
    serviceFee,
    discount,
    totalAmount,
    depositAmount,
    remainingAmount,
    promoCode,
    percentOff,
  };
}
